class DeadlyOutlawSettingsModel {
    public spaceToContinueSpinAndSkip: boolean = true;
    public spacePressed: boolean = false;
    public lastWinTime: number = 0;

    public buyout: boolean = false;

    
    public isBuyoutGame: boolean = false;
    
    public isCurrentBonusBuyOut: boolean = false;
    public totalBetOnBuyoutBonus: number;
    public totalValueOnBuyout: number;


    public savedCoinSize: number;
    public savedStakePerLine: number;
}

const doSettingsModel = new DeadlyOutlawSettingsModel();
export default doSettingsModel;



// WEBPACK FOOTER //
// ./src/model/do-settings-model.ts